import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { NavigationHistoryService } from '@shared/services';
import { ButtonIconComponent } from '@ui-kit/buttons';

@Component({
    selector: 'page-card',
    templateUrl: './page-card.component.html',
    styleUrls: ['./page-card.component.scss'],
    imports: [ButtonIconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class PageCardComponent {
    private navHistoryService = inject(NavigationHistoryService);

    isClosable = input<boolean>(true);
    customClose = input<boolean>(false);

    onClose = output<void>();

    onCloseClick(): void {
        if (this.customClose()) {
            this.onClose.emit();
            return;
        }

        this.goBack();
    }

    private goBack(): void {
        this.navHistoryService.goBack();
    }
}
